import React, { useRef } from 'react';
import classNames from 'classnames';
import { isNil } from 'lodash';
import { v4 as uuid } from 'uuid';
import { Button, Icon } from 'Permafrost/index';
import { StyledNumberField } from './NumberField.styles';
/**
 * Basic numeric input field. A label is required, but may be visually hidden
 * using the `hiddenLabel` property.
 */
export function NumberField(props) {
    // ensures unique value to associate label with input
    const fieldId = uuid();
    const { autoFocus, className, disabled, hiddenLabel, id, label, max, min, placeholder, readOnly = false, required, step, tabIndex, value, onChange, onClick, } = props;
    const inputEl = useRef(null);
    const increment = () => {
        const input = inputEl.current;
        if (input) {
            input.stepUp();
            // if !value OR value < min, set value to min or 1 - else increment by step
            isNil(value) || (!isNil(min) && value < min) ? onChange(min || 1) : onChange(+input.value);
        }
    };
    const decrement = () => {
        const input = inputEl.current;
        if (input) {
            input.stepDown();
            // if !value, set value to min or 0 - else if value > max, set value to max - else decrement by step
            isNil(value)
                ? onChange(min || 0)
                : !isNil(max) && value > max
                    ? onChange(max)
                    : onChange(+input.value);
        }
    };
    const handleChange = (event) => {
        var _a;
        // no validation for min or max - whatever value the user enters will be passed to onChange
        const targetValue = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value;
        onChange(targetValue === '' ? null : +targetValue);
    };
    return (React.createElement(StyledNumberField, { className: classNames(className, {
            hiddenLabel,
        }), "data-cy": props['data-cy'], id: id, onClick: onClick },
        React.createElement("input", { id: fieldId, "aria-label": hiddenLabel ? label : '', autoFocus: autoFocus, "data-testid": props['data-testid'], readOnly: readOnly, disabled: disabled, max: max, min: min, onChange: handleChange, placeholder: placeholder, ref: inputEl, required: required, step: step, tabIndex: tabIndex, type: "number", value: !isNil(value) ? value : '' }),
        !hiddenLabel ? React.createElement("label", { htmlFor: fieldId }, label) : null,
        readOnly ? null : (React.createElement("div", { className: "spin-buttons" },
            React.createElement(Button, { "data-testid": "increment-button", disabled: !isNil(value) && !isNil(max) && value >= max ? true : false, onClick: increment, tabindex: -1, variant: "no-style" },
                React.createElement(Icon, { name: "fa-caret-up", ariaLabel: "increase" })),
            React.createElement(Button, { "data-testid": "decrement-button", disabled: !isNil(value) && !isNil(min) && value <= min ? true : false, onClick: decrement, tabindex: -1, variant: "no-style" },
                React.createElement(Icon, { name: "fa-caret-down", ariaLabel: "decrease" }))))));
}
//# sourceMappingURL=NumberField.js.map